import React from 'react'

const CardMasterSvg = ({ width }) => {
  return (
    <svg
      width={width}
      viewBox='0 0 48 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M17.4 3H30.6V27H17.4V3Z' fill='#FF5F00' />
      <path
        d='M18.5 15C18.5 10.2 20.5 5.9 23.7 3C21.1 1.1 17.9 0 14.4 0C6.5 0 0 6.7 0 15C0 23.3 6.5 30 14.4 30C17.9 30 21.1 28.9 23.7 27C20.5 24.1 18.5 19.8 18.5 15Z'
        fill='#EB001B'
      />
      <path
        d='M48 15C48 23.3 41.5 30 33.6 30C30.1 30 26.9 28.9 24.3 27C27.6 24.1 29.5 19.8 29.5 15C29.5 10.2 27.6 5.9 24.3 3C26.9 1.1 30.1 0 33.6 0C41.5 0 48 6.7 48 15Z'
        fill='#F79E1B'
      />
    </svg>
  )
}

export default CardMasterSvg
